import ELK from 'elkjs/lib/elk.bundled.js'
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import {
    ReactFlow,
    addEdge,
    Panel,
    useNodesState,
    useEdgesState,
    useReactFlow,
    Controls,
    MiniMap,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import '../../App.css'
import DepartmentNode from './departmentNode'
import PositionNode from './positionNode'
import CustomEdge from './CustomEdge'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import Loading from '../../component/loading'
import ModalAddDepartment from '../../component/modals/modalAddDepartment'

const nodeTypes = {
    DepartmentNode,
    PositionNode,
}

const edgeTypes = {
    'custom-edge': CustomEdge,
}

const elk = new ELK()
const elkOptions = {
    'elk.algorithm': 'layered',
    'elk.layered.spacing.nodeNodeBetweenLayers': '100',
    'elk.spacing.nodeNode': '80',
}

const convertDataToNodesAndEdges = (
    departments,
    positions,
    handlerAddDepartment,
    handleIcon2Click
) => {
    const nodes = []
    const edges = []

    // ایجاد نودها برای بخش کاری‌ها
    departments.forEach((department) => {
        nodes.push({
            id: department.id,
            data: {
                label: department.name,
                handlerAddDepartment: () =>
                    handlerAddDepartment(department.id, department.parent_id),
                onClickIcon2: () =>
                    handleIcon2Click(department.id, department.parent_id),
            },
            type: 'DepartmentNode', // تغییر نوع به 'department'
            position: { x: 0, y: 0 },
        })
    })

    // ایجاد نودها برای موقعیت‌ها
    positions.forEach((position) => {
        nodes.push({
            id: position.id,
            data: {
                label: position.name,
                onClickIcon2: () =>
                    handleIcon2Click(position.id, position.parent_id),
            },
            type: 'PositionNode',
            position: { x: 0, y: 0 },
        })
    })

    // // ایجاد لبه‌ها برای ارتباطات بین بخش کاری‌ها
    // departments.forEach(department => {
    //     if (department.parent_id) {
    //         edges.push({
    //             id: `e${department.parent_id}-${department.id}`,
    //             source: department.parent_id,
    //             target: department.id,
    //             data: department,
    //             type: 'custom-edge',
    //         });
    //     }
    // });

    // ایجاد لبه‌ها برای ارتباطات بین بخش کاری‌ها و موقعیت‌ها
    positions.forEach((position) => {
        edges.push({
            id: `e${position.department_id}-${position.id}`,
            source: position.department_id,
            target: position.id,
            type: 'custom-edge',
            animated: true,
            data: position,
        })
    })

    return { nodes, edges }
}

const getLayoutedElements = (nodes, edges, options = {}) => {
    const isHorizontal = options?.['elk.direction'] === 'RIGHT'

    console.log(nodes, 'nodes')
    const graph = {
        id: 'root',
        layoutOptions: options,
        children: nodes.map((node) => ({
            ...node,
            targetPosition: isHorizontal ? 'left' : 'top',
            sourcePosition: isHorizontal ? 'right' : 'bottom',
            width: node.data.label.length * 15, // تنظیم عرض بر اساس طول برچسب
            height: 60, // تنظیم ارتفاع به صورت ثابت
        })),
        edges: edges,
    }

    return elk
        .layout(graph)
        .then((layoutedGraph) => ({
            nodes: layoutedGraph.children.map((node) => ({
                ...node,
                position: { x: node.x, y: node.y },
            })),
            edges: layoutedGraph.edges,
        }))
        .catch(console.error)
}

function PositionLayout({ selectedDepartment }) {
    const [nodes, setNodes, onNodesChange] = useNodesState([])
    const [edges, setEdges, onEdgesChange] = useEdgesState([])
    const { fitView } = useReactFlow()
    const [loading, setLoading] = useState(false)

    const [departmentData, setDepartmentData] = useState([selectedDepartment])

    const [positionData, setPositionData] = useState([])

    useEffect(() => {
        getPosition()
    }, [selectedDepartment])

    const getPosition = async () => {
        setLoading(true)

        const responseGet = await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position`,
            },
            resolve: (res) => {
                setPositionData(
                    res.data.filter(
                        (pos) => pos.department_id === selectedDepartment.id
                    )
                )
                setDepartmentData([selectedDepartment])
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerAddDepartment = (id, parentId) => {
        setIdAddDepartment(id)
        setShowModalAddDepartment(true)
        console.log(
            `Icon 1 clicked for department ${id} with parent ${parentId}`
        )
        // Add your custom logic here
    }

    const handleIcon2Click = (id, parentId) => {
        console.log(
            `Icon 2 clicked for department ${id} with parent ${parentId}`
        )
        // Add your custom logic here
    }

    const onConnect = useCallback(
        (connection) => {
            let edge = { ...connection, type: 'custom-edge' }
            const idConnection = edge.target
            const parentConnection = edge.source

            const searchDepartment = departmentData.find(
                (dep) => dep.id === idConnection
            )
            const searchPosition = positionData.find(
                (pos) => pos.id === idConnection
            )

            let nameConnection = ''
            if (searchDepartment) {
                nameConnection = searchDepartment.name
            } else if (searchPosition) {
                nameConnection = searchPosition.name
            }

            edge.data = {
                id: idConnection,
                name: nameConnection,
                parent_id: parentConnection,
            }

            setEdges((eds) => addEdge(edge, eds))
        },
        [setEdges, departmentData, positionData]
    )

    const onLayout = useCallback(
        ({ direction }) => {
            const opts = { 'elk.direction': direction, ...elkOptions }
            const { nodes: initialNodes, edges: initialEdges } =
                convertDataToNodesAndEdges(
                    departmentData,
                    positionData,
                    handlerAddDepartment,
                    handleIcon2Click
                )
            console.log(departmentData, positionData, 'nodes,edges')
            getLayoutedElements(initialNodes, initialEdges, opts).then(
                ({ nodes: layoutedNodes, edges: layoutedEdges }) => {
                    setNodes(layoutedNodes)
                    setEdges(layoutedEdges)
                    window.requestAnimationFrame(() => fitView())
                }
            )
        },
        [setNodes, setEdges, fitView, departmentData, positionData]
    )

    useLayoutEffect(() => {
        onLayout({ direction: 'DOWN' })
    }, [onLayout])

    const [idAddDepartment, setIdAddDepartment] = useState('')
    const [showModalAddDepartment, setShowModalAddDepartment] = useState(false)

    const openModalAddDepartment = (id) => {
        setIdAddDepartment(id)
        setShowModalAddDepartment((prev) => !prev)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            {showModalAddDepartment ? (
                <ModalAddDepartment
                    showModal={showModalAddDepartment}
                    setShowModal={setShowModalAddDepartment}
                    handlerSubmit={() => {}}
                    loadData={() => {
                        getPosition()
                    }}
                    id={idAddDepartment}
                />
            ) : null}
            <ReactFlow
                nodes={nodes}
                edges={edges}
                onConnect={onConnect}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                fitView
                id="flowTree"
                nodeTypes={nodeTypes}
                edgeTypes={edgeTypes}
                style={{ width: '100%', height: '100vh' }}
            >
                <Panel position="top-right">
                    <button
                        className="axis-flow-btn"
                        onClick={() => onLayout({ direction: 'DOWN' })}
                    >
                        نمایش عمودی
                    </button>
                    <button
                        className="axis-flow-btn"
                        onClick={() => onLayout({ direction: 'RIGHT' })}
                    >
                        نمایش افقی
                    </button>
                </Panel>
                <MiniMap />
                <Controls />
            </ReactFlow>
        </>
    )
}

export default PositionLayout
